import { Sheet } from '@/model/sheet';
import type { Workbook } from '@/model/workbook';
import clsx from 'clsx';

export function SheetsView({
  workbook,
  sheetIndex,
  setSheetIndex,
}: {
  workbook: Workbook;
  sheetIndex: number;
  setSheetIndex: (index: number) => void;
}) {
  return (
    <div className="flex gap-2">
      {workbook.sheets.map((sheet, index) => (
        <button
          className={clsx(
            'relative cursor-pointer rounded-t p-2 after:absolute hover:bg-gray-200',
            'after:absolute after:bottom-0 after:left-1/2 after:w-0 after:-translate-x-1/2 after:border-b-4 after:border-green-500 after:transition-all',
            index === sheetIndex && 'after:w-[75%] hover:after:w-full',
          )}
          key={index}
          onClick={() => setSheetIndex(index)}
        >
          {sheet.name}
        </button>
      ))}
      <button
        className="cursor-pointer rounded p-2 px-4 hover:bg-gray-200"
        onClick={() => {
          const newSheet = new Sheet(`Sheet ${workbook.sheets.length + 1}`);
          workbook.sheets.push(newSheet);
          setSheetIndex(workbook.sheets.length - 1);
        }}
      >
        +
      </button>
    </div>
  );
}
